import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import '../utils/video-main.css';

export default function VideoMain() {
  const lineRef = useRef(null);
  const videoRef = useRef(null);
  const [currentPhase, setCurrentPhase] = useState(1);
  const previousTimeRef = useRef(0);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    let animationTimeout1, animationTimeout2, animationTimeout3;

    const startAnimationCycle = () => {
      // Clear any existing timeouts
      clearTimeout(animationTimeout1);
      clearTimeout(animationTimeout2);
      clearTimeout(animationTimeout3);

      // Phase 1: Your Product (starts immediately)
      setCurrentPhase(1);

      // Phase 2: Infinite Iteration (after 2 seconds, stays until loop)
      animationTimeout1 = setTimeout(() => {
        setCurrentPhase(2);
      }, 2000);
    };

    const handleVideoLoop = () => {
      // Phase 3: Fade out when video loops
      setCurrentPhase(3);
      
      // Start new cycle after fade completes
      animationTimeout2 = setTimeout(() => {
        startAnimationCycle();
      }, 250); // Match fade duration
    };

    const handleVideoStart = () => {
      previousTimeRef.current = 0;
      startAnimationCycle();
    };

    const handleTimeUpdate = () => {
      const currentTime = video.currentTime;
      const previousTime = previousTimeRef.current;
      
      // Detect actual loop: previous time was near end, current time is near beginning
      if (previousTime > 1 && currentTime < 1) {
        handleVideoLoop();
      }
      
      previousTimeRef.current = currentTime;
    };

    // Start animation when video starts playing
    video.addEventListener('play', handleVideoStart);
    video.addEventListener('timeupdate', handleTimeUpdate);

    // Start initial animation cycle
    if (video.readyState >= 2) {
      startAnimationCycle();
    }

    return () => {
      video.removeEventListener('play', handleVideoStart);
      video.removeEventListener('timeupdate', handleTimeUpdate);
      clearTimeout(animationTimeout1);
      clearTimeout(animationTimeout2);
      clearTimeout(animationTimeout3);
    };
  }, []);

  return (
    <>
      
      <div className="video-container position-relative w-100" style={{ height: '100vh' }}>
        {/* Video Background */}
        <video
          ref={videoRef}
          className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
          style={{ objectPosition: 'top' }}
          src="video\itora-infinite_iteration-r4.mp4"
          autoPlay
          muted
          loop
          playsInline
        />

        {/* Text Container */}
        <div className="d-flex align-items-center justify-content-center d-none d-md-flex">
                          <div className="f-a position-absolute top-50 start-50 translate-middle w-100 px-4" style={{ lineHeight: '1', maxWidth: '900px', pointerEvents: 'none' }}>
            
            {/* Phase 1: Your Product */}
            {currentPhase === 1 && (
              <div className="d-flex justify-content-between align-items-center">
                <h1 className={`f-a phase-1-text`} style={{ color: '#000' }}>
                  your
                </h1>
                <div
                  style={{
                    flexGrow: 1,
                    height: '4px',
                    // marginInline: '0.75rem'
                  }}
                ></div>
                <h1 className={`f-a phase-1-text`} style={{ color: '#000' }}>
                  product
                </h1>
              </div>
            )}

            {/* Phase 2: Infinite Iteration */}
            {currentPhase === 2 && (
              <div className="d-flex justify-content-between align-items-center">
                <h1 className={`f-a phase-2-text`} style={{ color: '#000' }}>
                  infinite
                </h1>
                <div
                  ref={lineRef}
                  className="line-animate"
                  style={{
                    flexGrow: 1,
                    height: '4px',
                    background: '#000',
                    borderRadius: '999px',
                    transformOrigin: 'left center',
                    marginInline: '1.5rem',
                    transform: 'scaleX(0)'
                  }}
                ></div>
                <h1 className={`f-a phase-2-text`} style={{ color: '#000' }}>
                  iteration
                </h1>
              </div>
            )}

            {/* Phase 3: Fade Out */}
            {currentPhase === 3 && (
              <div className="d-flex justify-content-between align-items-center">
                <h1 className={`f-a phase-3-text`} style={{ color: '#000' }}>
                  infinite
                </h1>
                <div
                  style={{
                    flexGrow: 1,
                    height: '4px',
                    background: '#000',
                    borderRadius: '999px',
                    marginInline: '1rem',
                    opacity: 0
                  }}
                ></div>
                <h1 className={`f-a phase-3-text`} style={{ color: '#000' }}>
                  iteration
                </h1>
              </div>
            )}

          </div>
        </div>

                  {/* Bottom Text & CTA */}
        <div className="video-cta-container">
          <div className="d-flex align-items-center justify-content-center rounded floating-box" style={{ background: 'var(--ab-c0)', backdropFilter: 'blur(25px)' }}>
            <div className="text-block text-center me-3">
              <p style={{ fontSize: '0.9em', margin: 0 }} className="f-uc c-c00 lh-1">
                Lifelike avatars that replace real-world fashion models.
              </p>
            </div>
            <div className="">
              <Link to="/contact" className="btn c-c00 o-c00" style={{ fontSize: '0.9em', padding: '0.5rem 1rem' }}>Request Demo</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
